module.exports = __webpack_public_path__ + "static/img/active_01.65e9834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_01.jpg
// module id = DFdu
// module chunks = 0